/** «Sobre nosotros»: what the business wrote about itself, as it wrote it. Nothing when it wrote nothing. */
export function ProfileAbout({ about }: { about: string }) {
  if (about === "") return null;
  return (
    <section className="profile-section" aria-labelledby="profile-about">
      <h2 id="profile-about" className="profile-section-title">
        Sobre nosotros
      </h2>
      <p className="profile-about">{about}</p>
    </section>
  );
}
